import Converter from './Converter';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  gameListUrl: `winfinity/game/list`,
  converter,
  gameListUrlData: {
    getHeaders: () => ({
      'Content-Type': 'application/json',
      headers: { 'x-partner-name': projectName },
    }),
  },
  sessionUrlData: {
    url: `winfinity/game/launch`,
    getHeaders: () => ({
      'Content-Type': 'application/json',
      headers: { 'x-partner-authorization': parseCookies(), 'x-partner-name': projectName },
    }),
    getQuery: params =>
      // eslint-disable-next-line max-len
      `?game_id=${params.gameId}&player_device=${params.isMobile ? 2 : 1}&deposit_url=${encodeURIComponent(
        `${location.origin}/deposit`,
      )}&home_url=${location.origin}`,
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
  },
};
